export enum JobScheduleType {
	Yearly,
	Monthly,
	Weekly,
	Daily,
	Hourly,
	Minute,
	OneTime,
}
